var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0032 12.1644C16.2482 12.274 16.4659 12.4384 16.6564 12.6301C16.8469 12.8493 16.9558 13.0959 17.0374 13.4247C17.0919 13.7534 17.0919 14.1096 17.0102 14.5205L11.9207 36H8.03117C7.07859 36 6.45261 35.726 6.20766 35.1781C5.93549 34.6301 5.93549 33.9726 6.18044 33.1781L11.2155 12H15.1867C15.4589 12 15.731 12.0548 15.976 12.1644H16.0032Z",
    fill: "url(#paint0_linear_501_4123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5811 12.6301C41.3905 12.4384 41.1728 12.274 40.9279 12.1644H40.9007C40.6557 12.0548 40.3835 12 40.1114 12H36.1402L33.0849 24.8509L27.5223 13.1098L25.2768 22.6127L31.0791 35.0612C31.0955 35.1007 31.1132 35.1397 31.1323 35.1781C31.3773 35.726 32.0033 36 32.9558 36H36.8454L41.9349 14.5205C42.0165 14.1096 42.0165 13.7534 41.9621 13.4247C41.8805 13.0959 41.7716 12.8493 41.5811 12.6301Z",
    fill: "url(#paint1_linear_501_4123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.5146 13.103L32.4693 23.5565L27.5139 27.4184L22.0523 15.7842L27.5146 13.103Z",
    fill: "url(#paint2_linear_501_4123)",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5863 12.1644C26.8313 12.274 27.049 12.4384 27.2395 12.6301C27.43 12.8493 27.5389 13.0959 27.6205 13.4247C27.675 13.7534 27.675 14.1096 27.5933 14.5205L22.5038 36H18.6143C17.6617 36 17.0357 35.726 16.7908 35.1781C16.5186 34.6301 16.5186 33.9726 16.7635 33.1781L21.7986 12H25.7698C26.042 12 26.3141 12.0548 26.5591 12.1644H26.5863Z",
    fill: "url(#paint3_linear_501_4123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_4123",
    x1: 11.3151,
    y1: 35.5031,
    x2: 11.4035,
    y2: 12.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_501_4123",
    x1: 30.808,
    y1: 36,
    x2: 49.5482,
    y2: 22.4051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_501_4123",
    x1: 24.4208,
    y1: 15.9539,
    x2: 24.331,
    y2: 23.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_501_4123",
    x1: 21.8982,
    y1: 35.5031,
    x2: 21.9866,
    y2: 12.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuLogo);
export default __webpack_public_path__ + "static/media/leftmenu_logo.1b859c2120b3cedbaecdf6a3b62f48e6.svg";
export { ForwardRef as ReactComponent };